<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 25 25"
       role="presentation"
       @click="$emit('click')">
    <path :fill="disabled ? disabledStateColor : iconColor" fill-rule="evenodd" d="M18.585 11.667a1.006 1.006 0 1 0-.001-2.013 1.006 1.006 0 0 0 0 2.013zm-5.767 8.419a3.564 3.564 0 1 0 0-7.13 3.565 3.565 0 1 0 0 7.13zM11.298 6.62a1.25 1.25 0 1 0 0 2.5h3.039a1.25 1.25 0 0 0 0-2.5h-3.038zm8.18.63a3.159 3.159 0 0 1 3.158 3.16v5.968a3.158 3.158 0 0 1-3.158 3.159h-2.394a5.22 5.22 0 0 1-4.266 2.218 5.22 5.22 0 0 1-4.266-2.218H6.158A3.158 3.158 0 0 1 3 16.378v-5.967a3.159 3.159 0 0 1 3.158-3.16h2.12A2.253 2.253 0 0 1 10.532 5h4.574a2.252 2.252 0 0 1 2.25 2.252h2.123zm-6.66 7.203a2.067 2.067 0 1 1 .001 4.134 2.067 2.067 0 0 1-.001-4.134z"/>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>